<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Gestione accesso utenti</h1>
      </div>
      <p class="editor-lead">Imposta l'autorizzazione di accesso per ogni utente.</p>
    </header>

    <form class="editor-form" [formGroup]="usersForm">
      <section class="editor-panel">
        <h2>Utenti</h2>

        @if (hasLoaded && users.length === 0) {
          <p class="editor-hint">Nessun utente in elenco.</p>
        } @else {
          <div class="user-list" formArrayName="users">
            @for (user of users.controls; track user.get('id')?.value; let i = $index) {
              <div class="user-row" [formGroupName]="i">
                <div class="user-identity">
                  <span class="user-name">{{ user.get('nickname')?.value || '—' }}</span>
                  <span class="user-email">{{ user.get('email')?.value }}</span>
                </div>
                <select class="field auth-select" formControlName="authorization"
                  [attr.aria-label]="'Autorizzazione di ' + (user.get('nickname')?.value || 'utente')">
                  <option [ngValue]="0">Non autorizzato</option>
                  <option [ngValue]="1">Autorizzato</option>
                </select>
              </div>
            }
          </div>
        }
      </section>

      <div class="editor-actions">
        <button class="editor-save" type="button" [disabled]="!hasLoaded" (click)="save()">Salva</button>
      </div>
    </form>
  </div>
</div>
